/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import store from './store';
import User from '@js/libs/user';

// custom vue plugins
import Auth from './auth';
import VueTable2Checkbox from './plugins/vuetable2-checkbox';

// vue plugins
import VTooltip from 'v-tooltip';
import VeeValidate from 'vee-validate';

// mixins
// import globalMixin from './mixins/global/';
import vuexLoadingMixin from './mixins/vuex-loading';
import parsleyMixin from './mixins/parsley';
import LaravelErrorMixin from './mixins/validator-laravel-error';
import sweetalert2 from './mixins/swal';
import formattedDateMixin from './mixins/formatted-date';
import formattedNumberMixin from './mixins/formatted-number';

require('./bootstrap');
require('./components/components');

window.Laroute = require('./laroute');
window.numeral = require('numeral');
window.swal = require('sweetalert2');

require('eonasdan-bootstrap-datetimepicker');

// enable vue debug when not in production
const inProduction = process.env.NODE_ENV === 'production';
Vue.config.debug = !inProduction;
Vue.config.devtools = !inProduction;

// install vue plugin
require('./plugins/vuetable2');
Vue.use(Auth, { store: store, superAdminRole: 'inventory_admin' });
Vue.use(VueTable2Checkbox);
Vue.use(VTooltip);
Vue.use(VeeValidate, {
    inject: false,
    events: '',
});

Vue.mixin(vuexLoadingMixin);
Vue.mixin(LaravelErrorMixin);
Vue.mixin(sweetalert2);
Vue.mixin(formattedDateMixin);
Vue.mixin(formattedNumberMixin);
Vue.mixin(parsleyMixin);

const options = {
    el: '#app',
    store,
};

User.getAuthUser().then(() => {
    store.dispatch(`Auth/setUser`, User.getUser());
    // register vue router
    if (window.vueRoutes !== undefined) {
        options['router'] = require('./router')(window.vueRoutes);
    }

    const app = new Vue(options);
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js